module.exports = __webpack_public_path__ + "media/images/oyako_no_heya-6aa066e79781131b3ca05b97729ef97a.png";